<template>
	<div class="nav_box fs15">
		<div v-for="(item, index) in navList" :key="index">
			<div class="nav_item" :class="[info && info.institution_type == 1 ? (firstIndex == index ? 'active' : '') : firstIndex > 4 ? (firstIndex - 1 == index ? 'active' : '') : firstIndex == index ? 'active' : '', showMore ? 'show' : '', index == 0 ? 'account' : '', info && info.institution_type == 1 ? `nav${index + 1}` : index > 4 ? `nav${index + 2}` : `nav${index + 1}`]" @click="toFirst(index, item.link)">
				<i class="icon"></i>
				{{ item.title }}
				<i class="arrow"></i>
			</div>
			<div class="my_account" :class="showMore ? 'show' : ''" v-if="item.children.length > 0">
				<div class="second_item" :class="secondIndex == i ? 'active' : ''" @click="toSecond(i, t.link)" v-for="(t, i) in item.children" :key="i">
					{{ t.title }}
				</div>
			</div>
		</div>
	</div>
</template>
<script>
	export default {
		props: ["firstIndex", "secondIndex"],
		data() {
			return {
				showMore: true,
				navList: [],
				info: null,
			};
		},
		created() {
			let that = this;
			that.navList = [
				{
					title: "我的账户",
					link: "",
					children: [
						{ title: "基本信息", link: "BaseInfo" },
						{ title: "会员中心", link: "Vip" },
						{ title: "收货地址", link: "Address" },
					],
				},
				{ title: "我的订单", link: "Order", children: [] },
				{ title: "我的收藏", link: "Collection", children: [] },
				{ title: "发票管理", link: "Invoice", children: [] },
				{ title: "积分明细", link: "IncomeDetail", children: [] },
				//{ title: '子机构管理', link: 'SubManage', children: [] },
				{ title: "服务条款", link: "ServiceTerm", children: [] },
				{ title: "帮助中心", link: "HelpCenter", children: [] },
				{ title: "关于我们", link: "AboutUs", children: [] },
				//{ title: '客服', link: 'CustomerSer', children: [] },
			];
			let userinfo = this.$cookies.get("userinfo");
			this.info = userinfo;
			if (userinfo && userinfo.institution_type == 1) {
				that.navList = [
					{
						title: "我的账户",
						link: "",
						children: [
							{ title: "基本信息", link: "BaseInfo" },
							{ title: "会员中心", link: "Vip" },
							{ title: "收货地址", link: "Address" },
						],
					},
					{ title: "我的订单", link: "Order", children: [] },
					{ title: "我的收藏", link: "Collection", children: [] },
					{ title: "发票管理", link: "Invoice", children: [] },
					{ title: "积分明细", link: "IncomeDetail", children: [] },
					{ title: "子机构管理", link: "SubManage", children: [] },
					{ title: "服务条款", link: "ServiceTerm", children: [] },
					{ title: "帮助中心", link: "HelpCenter", children: [] },
					{ title: "关于我们", link: "AboutUs", children: [] },
					//{ title: '客服', link: 'CustomerSer', children: [] },
				];
			}
		},
		methods: {
			toFirst(index, link) {
				if (index == 0) {
					this.showMore = !this.showMore;
				} else {
					this.$router.push("/" + link);
				}
			},
			toSecond(index, link) {
				this.$router.push("/" + link);
			},
		},
	};
</script>
<style lang="less" scoped>
	.nav_box {
		width: 180px;
		background: #fff;
		padding-bottom: 10px;

		.nav_item {
			line-height: 50px;
			cursor: pointer;
			padding: 0 0 0 60px;
			position: relative;

			.icon {
				display: block;
				width: 24px;
				height: 24px;
				background-repeat: no-repeat;
				background-position: center;
				background-size: 100%;
				position: absolute;
				left: 20px;
				top: 0;
				bottom: 0;
				margin: auto;
			}

			&.account .arrow {
				content: "";
				display: block;
				width: 16px;
				height: 16px;
				background: url("/src/assets/static/icon/c_arrowd.png") no-repeat center;
				background-size: 100%;
				position: absolute;
				right: 20px;
				top: 0;
				bottom: 0;
				margin: auto;
				transition: all ease 0.5s;
				transform: rotate(-90deg);
			}

			&.account.show .arrow {
				transform: rotate(0);
			}

			&:hover,
			&.active {
				color: #1275ff;
				background: #3d7efe0a;
			}

			&:hover::before,
			&.active::before {
				display: block;
				content: "";
				height: 100%;
				width: 7px;
				background: #1275ff;
				position: absolute;
				left: -7px;
				top: 0;
			}

			&:hover::after,
			&.active::after {
				display: block;
				content: "";
				width: 10px;
				height: 10px;
				background: #1275ff;
				border-radius: 50%;
				position: absolute;
				right: 14px;
				top: 0;
				bottom: 0;
				margin: auto;
			}

			&.account:hover::after,
			&.active.account::after {
				display: none;
			}
		}
	}

	.make_nav(@n, @i: 1) when (@i =< @n) {
		.nav@{i} .icon {
			background-image: url("/src/assets/static/icon/c_personal@{i}.png");
		}

		.nav@{i}.active .icon,
		.nav@{i}:hover .icon {
			background-image: url("/src/assets/static/icon/c_personal@{i}-on.png");
		}

		.make_nav(@n, (@i + 1));
	}

	.make_nav(10);

	.my_account {
		height: 0;
		transition: all ease 0.5s;
		overflow: hidden;

		&.show {
			height: 150px;
		}

		.second_item {
			line-height: 50px;
			cursor: pointer;
			padding: 0 0 0 60px;
			position: relative;

			&:hover,
			&.active {
				color: #1275ff;
				background: #3d7efe0a;
			}

			&:hover::after,
			&.active::after {
				display: block;
				content: "";
				width: 12px;
				height: 12px;
				background: #1275ff;
				border-radius: 50%;
				position: absolute;
				right: 20px;
				top: 0;
				bottom: 0;
				margin: auto;
			}
		}
	}
</style>
